"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M8.524 1h1.42V0h-3.84v1h1.419v1.506C4.019 2.753 1.24 5.675 1.24 9.24A6.767 6.767 0 0 0 8 16a6.766 6.766 0 0 0 6.758-6.76 6.708 6.708 0 0 0-1.254-3.921l-.813.58a5.722 5.722 0 0 1 1.067 3.342A5.765 5.765 0 0 1 8 15a5.766 5.766 0 0 1-5.76-5.76A5.766 5.766 0 0 1 8 3.484c1.568 0 3.026.619 4.119 1.74l.226.237 1.868-1.782-.69-.724-1.172 1.118a6.668 6.668 0 0 0-3.828-1.564V1Zm-.99 8.29a.674.674 0 0 0 1.347.048l2.514-2.382-.688-.727-2.52 2.388a.675.675 0 0 0-.652.673Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M11.473 1.172H9.317V.047h5.436v1.125h-2.155v2.675a9.93 9.93 0 0 1 6.03 2.463l1.746-1.695.784.807-2.53 2.456-.03-.03-.001.002-.051-.056-.074-.077A8.861 8.861 0 0 0 12 4.942c-4.93 0-8.942 4.012-8.942 8.943 0 4.93 4.011 8.943 8.942 8.943s8.943-4.012 8.943-8.943a8.88 8.88 0 0 0-1.658-5.189l.915-.653a9.999 9.999 0 0 1 1.868 5.842c0 5.551-4.517 10.068-10.068 10.068-5.55 0-10.067-4.517-10.067-10.068 0-5.373 4.234-9.764 9.54-10.041V1.172Zm4.63 8.417-3.551 3.367a1.03 1.03 0 1 0 .782.809l3.542-3.36-.774-.816Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M15.297 1.563h-2.874v-1.5h7.248v1.5h-2.874V5.13a13.24 13.24 0 0 1 8.04 3.283l2.329-2.26L28.21 7.23l-3.374 3.274-.04-.04-.001.003-.068-.075-.1-.102c-2.28-2.39-5.337-3.7-8.628-3.7-6.574 0-11.923 5.349-11.923 11.924 0 6.574 5.349 11.923 11.923 11.923 6.575 0 11.924-5.35 11.924-11.923a11.84 11.84 0 0 0-2.211-6.92l1.22-.87a13.331 13.331 0 0 1 2.49 7.79c0 7.4-6.021 13.423-13.423 13.423-7.401 0-13.423-6.022-13.423-13.423 0-7.165 5.646-13.02 12.72-13.39v-3.56Zm6.172 11.222-4.734 4.49a1.374 1.374 0 1 0 1.043 1.078l4.723-4.48-1.032-1.088Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m38.899 17.2 1.526-1.088a20.031 20.031 0 0 1 3.74 11.701c0 11.119-9.046 20.165-20.165 20.165-11.12 0-20.165-9.046-20.165-20.165 0-10.828 8.58-19.688 19.299-20.144V1.897h-4.36V.022H29.37v1.875h-4.36v5.776a19.92 19.92 0 0 1 12.45 5.129l3.457-3.458 1.326 1.326-4.496 4.496h-.001l-.264.291a2.796 2.796 0 0 1-.168-.183C33.798 11.555 29.078 9.523 24 9.523c-10.085 0-18.29 8.205-18.29 18.29 0 10.085 8.205 18.29 18.29 18.29 10.086 0 18.29-8.205 18.29-18.29 0-3.834-1.172-7.504-3.391-10.612Zm-13.564 8.802 6.955-6.596 1.29 1.36-6.945 6.586c.06.194.102.396.102.61a2.084 2.084 0 1 1-2.084-2.084c.24 0 .466.05.682.124Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m51.865 22.934 2.035-1.452a26.708 26.708 0 0 1 4.987 15.602C58.887 51.909 46.825 63.97 32 63.97c-14.826 0-26.887-12.062-26.887-26.887 0-14.438 11.441-26.25 25.732-26.858V2.529h-5.813v-2.5h14.126v2.5h-5.813v7.702a26.56 26.56 0 0 1 16.6 6.838l4.61-4.61 1.767 1.768-5.995 5.995v-.001l-.353.389a3.686 3.686 0 0 1-.224-.245c-4.686-4.958-10.979-7.668-17.75-7.668-13.447 0-24.387 10.94-24.387 24.387C7.613 50.53 18.553 61.47 32 61.47c13.447 0 24.387-10.94 24.387-24.387a24.22 24.22 0 0 0-4.522-14.15ZM33.78 34.669l9.274-8.795 1.72 1.814-9.26 8.78c.08.26.136.53.136.815a2.78 2.78 0 1 1-2.78-2.78c.32 0 .623.067.91.166Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconStopwatch = function IconStopwatch(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Stopwatch' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Stopwatch"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconStopwatch.sizes = [16, 24, 32, 48, 64];
IconStopwatch.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconStopwatch;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/account-experience/Stopwatch.js
// module id = 1871
// module chunks = 0